import React from 'react';
import AdminQueueContainer from '../components/adminQueue.container';

/** `/admin/queue` — the global transcription queue, for finding a stuck job. */
const AdminQueuePage: React.FC = () => <AdminQueueContainer />;

export default AdminQueuePage;
